import { render, staticRenderFns } from "./UiMediaPicker.vue?vue&type=template&id=b2f249fa&"
import script from "./UiMediaPicker.vue?vue&type=script&lang=js&"
export * from "./UiMediaPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports